var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{class:{
			mobile: _vm.$store.getters.layout == 'Mobile',
		}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showHeader),expression:"$route.meta.showHeader"}],class:{
				'mobile-top-container': _vm.$store.getters.layout == 'Mobile',
			}},[_c('top',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showHeader),expression:"$route.meta.showHeader"}],attrs:{"showTopNav":_vm.$route.meta.showTopNav}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showTopNav),expression:"$route.meta.showTopNav"}],class:{
				'mobile-sports_list-container': _vm.$store.getters.layout == 'Mobile',
			}},[_c('div',{staticClass:"sports-list-wrapper"},[_c('sports-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showTopNav),expression:"$route.meta.showTopNav"}]})],1)]),_vm._v(" "),_c('div',{class:{
				'mobile-router_view-container': _vm.$store.getters.layout == 'Mobile',
			}},[_c('keep-alive',{attrs:{"include":[
					'home',
					'live',
					'Jengabet',
					'boosted-multibet',
					'casino',
					'casino-category',
					'my-bets',
				]}},[_c('router-view')],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showFooter),expression:"$route.meta.showFooter"}],class:{
				'mobile-bottom-container': _vm.$store.getters.layout == 'Mobile',
			}},[(_vm.showMiniBetslip)?_c('mini-betslip'):_vm._e(),_vm._v(" "),_c('bottom',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showFooter),expression:"$route.meta.showFooter"}]}),_vm._v(" "),(_vm.env.supportContactsTab.enabled && _vm.contactsTabSupportsLayout)?_c('support-contacts'):_vm._e(),_vm._v(" "),(_vm.env.zendeskChat.enabled)?_c('zendesk-chat'):_vm._e(),_vm._v(" "),(
					_vm.env.availableFeatures.accaBonus &&
					['home', 'prebets-markets', 'live', 'live-markets'].includes(
						_vm.$route.name
					)
				)?_c('acca-on-mini-betslip'):_vm._e(),_vm._v(" "),_c('data-notifier')],1),_vm._v(" "),(
				_vm.env.availableFeatures.scratchToWinPromo &&
					_vm.$route.name == 'home' &&
					!_vm.checkDayIfWeekend &&
					!_vm.isIOS()
			)?_c('scratch-to-win-promo'):_vm._e(),_vm._v(" "),(_vm.roadBlockBanner && _vm.env.availableFeatures.roadBlockBanner &&
				_vm.$route.name == 'home')?_c('road-block-banner',{attrs:{"imageUrl":_vm.roadBlockBanner.imageUrl,"showCTAs":_vm.roadBlockBanner.showCta,"routerBtn":{
				title: _vm.$t(_vm.roadBlockBanner.routerBtn.title),
				path: _vm.roadBlockBanner.routerBtn.path,
			},"btnStyle":'block',"roadblockLink":_vm.roadBlockBanner.route}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }